import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CombinedStore } from 'src/app/core/combined.store';
import { Product } from '../constants/product.constants';
import { PERSONALIZATION_PATH } from '../constants/route.constants';
import { SharedDataService } from '../services/shared-data.service';
import { findHousingSubscriptionStepIndex } from '../utils/housing-subscription.factory';

@Injectable({
  providedIn: 'root',
})
export class StepActivationGuard implements CanActivate {
  store = inject(CombinedStore);
  constructor(private sharedDataService: SharedDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url.split('/')[2];
    const subscription = this.sharedDataService.getSubscription();
    let fallbackIndex = findHousingSubscriptionStepIndex(currentUrl!);

    if (
      this.store.context().produit === Product.HN &&
      !this.store.context().referenceContrat &&
      !this.store.context().referenceDevis &&
      this.store.context().partnerCode
    ) {
      const personalizationIndex = findHousingSubscriptionStepIndex(PERSONALIZATION_PATH);
      fallbackIndex = personalizationIndex ?? fallbackIndex;
    }

    const index = subscription()?.findStepIndexesByUrl(currentUrl!) ?? fallbackIndex;
    if (index) {
      this.sharedDataService.setGroupStep(index.groupIndex);
      this.sharedDataService.setStepIndex(index.stepIndex);
    }

    return true;
  }
}
